import { useLocation, Outlet, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import NavBar from "./components/layout/navbar/NavBar";
import FooterSection from "./components/layout/footer/Footer";
import { useState, useEffect } from "react";
import { FloatButton, Form, notification, Input, Image } from "antd";
import ChatBotSlideIn from "./components/common/chatbot-drawer/chatBotSlideIn";
import { nanoid } from "nanoid";
import RouteTracker from "./routes/RoutesTracker";
import { useMediaQuery } from "react-responsive";
import "./App.css";
import {
  connectWebSocket,
  disconnectWebSocket,
} from "./components/common/utils/WebSocket";
import Chatbot from "./features/Chatbot/chatbot";
import CampaignCreationSteps from "./features/BuyerFlow/campaign-creation/CampaignCreationSteps";

function App() {
  const location = useLocation();
  const userRole = useSelector((state) => state.login.userType);
  const { userId } = useSelector((state) => state.login);
  const { clientId } = useSelector((state) => state.userprofile);
  const isLoggedIn = useSelector((state) => state.login.isAuthenticated);
  const isRehydrated = useSelector((state) => state._persist?.rehydrated);
  const isDesktop = !useMediaQuery({ maxWidth: 768 });
  const isBuyerRoute = location.pathname.startsWith("/buyer");
  const isSellerRoute = location.pathname.startsWith("/seller");
  const isPublicProducts = location.pathname === "/products";
  const isPrivacyPolicies = location.pathname === "/privacy-policy";
  const isAuthPage = ["/login", "/signup", "/reset-password"].includes(
    location.pathname,
  );
  const isBuyerUser = !isLoggedIn || userRole === "basic";
  const hideCampaignStepsOnPaths = [
    "/about",
    "/contact",
    "/privacy-policy",
    "/not-found",
    "/rfp",
    "/get-in-touch",
    "/get-in-touch/success",
    "/home",
    "/io-signing/success",
  ].includes(location.pathname);
  const isDetailPage = ["/productsdetails"].includes(location.pathname);
  const isNotFound = [
    "/not-found",
    "/rfp",
    "/get-in-touch",
    "/get-in-touch/success",
  ].includes(location.pathname);
  const [Advertise, SetAdvertise] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [form] = Form.useForm();
  const [openSlideIn, setOpenSlideIn] = useState(false);
  const isHome = location.pathname === "/home";
  const openChatBot = () => {
    const uniqueSessionId = nanoid();
    sessionStorage.setItem("sessionId", uniqueSessionId);
    setOpenSlideIn(true);
  };
  const { isLiveMsg } = useSelector((state) => state.webSocketMsgs);
  const { isChatModal } = useSelector(
    (state) => state.chatCommunicationHandleSlice,
  );
  const [api, contextHolder] = notification.useNotification();
  const [forceOpenChatbot, setForceOpenChatbot] = useState(false);
  useEffect(() => {
    const newSessionId = nanoid();
    sessionStorage.setItem("sessionId", newSessionId);
  }, []);
  const hideChatbotOnPaths = [
    "/buyer/campaign-payment",
    "/not-found",
    "/get-in-touch",
  ];
  const shouldHideChatbot = hideChatbotOnPaths.some((path) =>
    location.pathname.startsWith(path),
  );

  useEffect(() => {
    if (!isRehydrated || !isLoggedIn || !userRole) return;
    let socketId = userRole === "basic" ? userId : clientId;
    if (!socketId) return;
    connectWebSocket(socketId);

    // ONLY disconnect when tab/browser is closed
    const handleUnload = () => {
      disconnectWebSocket();
    };

    window.addEventListener("beforeunload", handleUnload);

    return () => {
      window.removeEventListener("beforeunload", handleUnload);
      //  DO NOT disconnect here
    };
  }, [isRehydrated, isLoggedIn, userId, clientId, userRole]);
  // Used to get utm_source from url and store it in the localstorage
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const utmSource = params.get("utm_source")?.trim();
    if (utmSource) {
      localStorage.setItem("utm_source", utmSource);
    } else {
      localStorage.removeItem("utm_source");
    }
  }, []);
  const openNotification = () => {
    api.open({
      message: <strong>You have a Msg from seller</strong>,
      description: isLiveMsg.message,
      className: "custom-class",
      placement: "bottomRight",
      style: {
        width: 400,
      },
    });
  };
  useEffect(() => {
    const shouldOpenChatbot = sessionStorage.getItem("openChatbot");
    if (shouldOpenChatbot === "true" && isLoggedIn) {
      setForceOpenChatbot(true);
      sessionStorage.removeItem("openChatbot");
    }
  }, [isLoggedIn]);
  const navigate = useNavigate();
  useEffect(() => {
    if (!isLoggedIn) return;
    const returnToShopMapView = sessionStorage.getItem("returnToShopMapView");
    if (returnToShopMapView === "true") {
      sessionStorage.removeItem("returnToShopMapView");
      navigate("/products?mapView=true", { replace: true });
    }
  }, [isLoggedIn, navigate]);
  return (
    <>
      <div style={{ marginTop: -20 }}>
        {contextHolder}
        <div className={isDesktop ? "set-overflow" : ""}>
          {!isAuthPage && (
            <>
              <NavBar
                isLoggedIn={isLoggedIn}
                userRole={userRole}
                Advertise={Advertise}
                SetAdvertise={SetAdvertise}
                setSelectedImage={setSelectedImage}
                selectedImage={selectedImage}
                form={form}
              />
              {!hideCampaignStepsOnPaths && isBuyerUser && (
                <CampaignCreationSteps />
              )}
            </>
          )}
          <Outlet />
          {!isAuthPage &&
            !isBuyerRoute &&
            !isDetailPage &&
            !isSellerRoute &&
            !isPublicProducts &&
            !isNotFound &&
            !isPrivacyPolicies && <FooterSection SetAdvertise={SetAdvertise} />}
        </div>
        {!shouldHideChatbot && (
          <>
            <div className="">
              <Chatbot forceOpen={forceOpenChatbot} form={form} />
            </div>
          </>
        )}
        <ChatBotSlideIn
          openChatBot={openSlideIn}
          setOpenChatBot={setOpenSlideIn}
        />
        <RouteTracker />
      </div>
    </>
  );
}

export default App;
